import axios from 'axios';
import { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useParams } from 'react-router-dom';
import PageLoader from '../../components/global/loader/PageLoader';
import { SingleInternalBanner } from '../../components/internals/SingleInternalBanner';
import jQuery from 'jquery';
import './styles.scss';
export const SingleBlog = () => {
    const { slug } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const [author, setAuthor] = useState(null);
    const [authorAcf, setAuthorAcf] = useState(null);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        document.title = "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
        fetchPageContet(slug);
    }, [slug]);

    
    const fetchPageContet = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=fetch_single_blog_by_slug&slug=${slug}`);
            console.log(data)
            if (data?.post) {
                document.title = data?.post?.post_title ? `${data?.post?.post_title}` : "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
                if (document.querySelector('#wp-admin-bar-edit a')) {
                    document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Post`;
                    document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.post?.ID}&action=edit`;
                }
            }

            setPageContent(data?.post ?? null);
            setAuthor(data?.author ?? null);
            setAuthorAcf(data?.author_acf ?? null);
            setCategories(data?.categories ?? []);
            setFeaturedImage(data?.featured_image ?? null);

            setTimeout(() => {
                jQuery("#table-of-contents").html("");
                var toc = jQuery("#table-of-contents");
                var lastLevel = 2; // Assuming the first heading level is H2
                let count = 0;
                jQuery("article h2, article h3").each(function(index) {
                    count ++;
                    var heading = jQuery(this);
                    var headingText = heading.text();

                    var anchor = headingText.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/\s+/g, '-').toLowerCase();
                    heading.attr('id', anchor);
                    var level = parseInt(this.tagName.substring(1));
                    
                    if (level > lastLevel) {
                        // Start a new sublist
                        var sublist = jQuery("<ul>");
                        toc.find('li:last').append(sublist);
                        toc = sublist;
                    } else if (level < lastLevel) {
                        // End current sublist(s)
                        toc = toc.parents('ul').last();
                    }
                    
                    lastLevel = level;
                    if (anchor?.length > 1) {
                        var listItem = jQuery('<li>').appendTo(toc);
                        listItem.append(jQuery('<a>').attr('href', '#' + anchor).text(headingText));
                    }
                });

                if (count < 1) {
                    jQuery("#table-of-contents").html("<li className='no-contents'>No Contents</li>");
                }

                jQuery('#table-of-contents a').on('click', function (e) {
                    let elementId = jQuery(this).attr('href');

                    var elementTop = jQuery(elementId).offset()?.top ?? 0;
                    var viewportHeight = jQuery(window).height();
                    var newScrollTop = elementTop - (viewportHeight / 2);
                  
                    window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
                    e.stopPropagation();
                    return false;
                  });
            }, 600);

            window.addEventListener('scroll', highlightActiveItem);


        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const highlightActiveItem = () => {
        var headings = jQuery("h2, h3");
        var tocLinks = jQuery("#table-of-contents a");
        
        headings.each(function(index) {
            if (isElementInViewport(this)) {
                tocLinks.removeClass("active");
                var currentAnchor = jQuery(this).attr("id");
                tocLinks.filter("[href='#" + currentAnchor + "']").addClass("active");
            }
        });
    }




    return <Fade delay={1}>
        <main id='main' className="internal-page single">
            {!isFetching && <>
                <SingleInternalBanner page={pageContent} author={author} categories={categories} />
                <section id="main-article-content">           
                    <div className="container">
                        <div className="sidebar-inner-wrapper">
                            <article>
                            <div dangerouslySetInnerHTML={{ __html: pageContent?.post_content }} />

                            <div id="author-bio">
                            <div className="author-bio-title">About the Author</div>
                            <div className="author-bio-content">
                                {authorAcf?.author_headshot?.url && (
                                    <img src={authorAcf.author_headshot.url} alt={authorAcf?.author_name || ''} />
                                )}
                                <div className="author-details">
                                {authorAcf?.author_name && (
                                    <span className="author-name">{authorAcf.author_name}</span>
                                )}
                                {authorAcf?.author_bar_number && (
                                    <span className="author-bar-number">{authorAcf.author_bar_number}</span>
                                )}
                                {authorAcf?.author_bio && (
                                    <p className="author-description">{authorAcf.author_bio}</p>
                                )}
                                {authorAcf?.author_email && (
                                <div className="author-contact-info">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    >
                                    <mask
                                        id="mask0_2006_58"
                                        style={{ maskType: 'alpha' }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                    >
                                        <rect width="24" height="24" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_2006_58)">
                                        <path
                                        d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z"
                                        fill="#1C1B1F"
                                        />
                                    </g>
                                    </svg>
                                    <span className="author-email">{authorAcf.author_email}</span>
                                </div>
                                )}
                                </div>
                            </div>
                            </div>
                        </article>
                            <aside>
                                {
                                    featuredImage && <div className='featured-image' dangerouslySetInnerHTML={{__html: featuredImage}} />
                                }
                                <div className='toc-wrapper'>
                                    <span className='title'>Page Contents</span>
                                    <ul id="table-of-contents">
                                        
                                    </ul> 
                                </div>
                            </aside>
                        </div>
                    </div>
                </section>
            </>}
            {
                isFetching && <PageLoader />
            }
        </main>
    </Fade>
}